var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 .937a8.061 8.061 0 0 0-5.7 13.764 8.062 8.062 0 0 0 5.7 2.362A8.075 8.075 0 0 0 18.063 10 8.06 8.06 0 0 0 10 1.937Zm.073 3.3c.207 0 .375.168.375.375v.68c.681.081 1.323.37 1.838.824a.372.372 0 1 1-.506.545 2.775 2.775 0 0 0-1.33-.607v2.57c1.406.432 2.2 1.238 2.168 2.224 0 1.276-1.219 1.837-2.174 1.95v.607a.375.375 0 1 1-.75 0v-.62c-.727-.112-1.778-.544-2.227-.993a.37.37 0 1 1 .525-.525c.32.3 1.125.638 1.707.77V10.19c-.757-.191-2.174-.586-2.174-1.823 0-1.105.898-1.95 2.174-2.081v-.674c0-.207.167-.374.374-.374Zm.376 5.176v2.642c.527-.093 1.445-.354 1.418-1.18 0-.768-.744-1.22-1.418-1.462ZM9.7 7.04c-.723.115-1.417.543-1.417 1.33 0 .602.81.884 1.417 1.051Z",
    stroke: "currentColor",
    strokeWidth: 0.563,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.256a4.256 4.256 0 1 0 0-8.511 4.256 4.256 0 0 0 0 8.511Z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0-.744a4.256 4.256 0 1 0 0-8.511 4.256 4.256 0 0 0 0 8.511Z",
    stroke: "currentColor",
    strokeWidth: 0.5,
    fill: "currentColor",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#565f74",
    strokeWidth: 0.5,
    fill: "#565f74",
    fillRule: "nonzero",
    d: "M20 15.444 19.588 15l-1.583 1.622L16.423 15l-.423.444 2.005 2.056z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBank);
export default __webpack_public_path__ + "static/media/nav-bank.949778e5d7f0bcddba2337f26e66c63d.svg";
export { ForwardRef as ReactComponent };